import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { FichasAbas } from "@/components/MercadoriaFichas";

export const FichasBusca = ({ busca, de, ate }) => {
  const [fichas, setFichas] = useState(null);

  useEffect(() => {
    setFichas(null);
    const t = setTimeout(() => {
      api.get("/dashboard/mais-vendidas/fichas", { params: { busca, de, ate } })
        .then((r) => setFichas(r.data.fichas))
        .catch((e) => toast.error(apiError(e.response?.data?.detail)));
    }, 350);
    return () => clearTimeout(t);
  }, [busca, de, ate]);

  return (
    <section className="mb-8" data-testid="mv-busca-fichas">
      <h2 className="font-display text-lg font-bold text-foreground mb-3">Fichas com "{busca}"</h2>
      <FichasAbas key={busca} fichas={fichas} mostrarProduto vazioExtra={de || ate ? " nesse período" : ""} />
    </section>
  );
};
